import { useState } from 'react'
import { toast } from 'sonner'
import { useConfirm } from '@/components/common/ConfirmDialog'
import { useParties, useDeleteParty } from '../../parties/hooks'
import { ContractPartyRow } from './ContractPartyRow'
import { AddPartyDialog } from './AddPartyDialog'

/** Panel osób na umowie - lista osób z rolami, dodawanie i usuwanie. */
export function ContractPartiesPanel({ contractId }: { contractId: number }) {
  const confirm = useConfirm()
  const parties = useParties(contractId)
  const del = useDeleteParty(contractId)
  const [adding, setAdding] = useState(false)

  if (parties.isLoading) {
    return <p className="text-xs text-slate-400 italic p-4">Ładowanie osób…</p>
  }

  return (
    <div className="flex flex-col gap-2 p-4 max-w-2xl">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold">Osoby na umowie</h3>
        <button
          onClick={() => setAdding(true)}
          className="text-[11px] bg-sky-600 text-white rounded px-2 py-1"
        >+ Dodaj osobę</button>
      </div>
      <div>
        {parties.data?.map(p => (
          <ContractPartyRow
            key={p.id}
            party={p}
            onDelete={async () => {
              const ok = await confirm({
                title: 'Usunąć osobę z umowy?',
                description: 'Operacja jest nieodwracalna.',
                confirmLabel: 'Usuń',
                variant: 'destructive',
              })
              if (ok) del.mutate(p.id, { onError: (err) => toast.error(formatError(err)) })
            }}
          />
        ))}
      </div>
      {adding && <AddPartyDialog contractId={contractId} onClose={() => setAdding(false)} />}
    </div>
  )
}

function formatError(err: unknown): string {
  const ax = err as { response?: { data?: { detail?: string; title?: string } } }
  return ax.response?.data?.detail ?? ax.response?.data?.title ?? 'Błąd'
}
